// src/pages/CozulenApplicationsPage.js

import React from 'react';
import ApplicationsPage from './ApplicationsPage';

const ResolvedApplicationsPage  = () => {
  return <ApplicationsPage statusName="çözüldü" pageTitle="Çözülen Başvurular" />;
};


export default ResolvedApplicationsPage;
